exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dataTable{border-bottom:1px solid rgba(0,0,0,.12);border-radius:0}.dataTable .v-data-table-header tr th span{font-size:14px!important}a{text-decoration:none}.allPhonesContainer{display:flex;flex-direction:column;padding:4px 0}.individualPhoneContainer{display:flex;padding:2px}.individualPhoneContainer i{margin-right:3px}", ""]);

// exports
